import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import GlassCard from '../UI/GlassCard';
import SectionHeader from '../UI/SectionHeader';
import Tag from '../UI/Tag';

const skillCategories =[
  { title: 'Frontend', icon: 'terminal', tags: ['ReactJS', 'TypeScript', 'JavaScript', 'HTML/CSS', 'Jest'] },
  { title: 'Backend', icon: 'database', tags:['NodeJS', 'PostgreSQL', 'Python', 'Flask', 'Odoo'] },
  { title: 'Mobile', icon: 'smartphone', tags:['Flutter', 'Dart', 'Riverpod', 'Cross-Platform'] },
  { title: 'Cloud & Design', icon: 'cloud', tags:['GCP', 'Docker', 'CI/CD', 'Git', 'Agile', 'Figma'] }
];

const Skills = () => {
  return (
    <Box id="skills-deep-dive" sx={{ py: 16, bgcolor: 'custom.midnight', borderTop: '1px solid', borderBottom: '1px solid', borderColor: 'custom.white5' }}>
      <Container maxWidth="lg" sx={{ px: 3 }}>
        <SectionHeader number="05" title="Skills Deep Dive" description="Technical Proficiency" />

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' }, gap: 3 }}>
          {skillCategories.map((cat, idx) => (
            <GlassCard key={idx} sx={{ p: 4 }}>
              <Typography sx={{ fontFamily: 'mono', fontSize: '0.75rem', color: 'primary.main', textTransform: 'uppercase', letterSpacing: '0.1em', mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>{cat.icon}</span> {cat.title}
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {cat.tags.map(tag => <Tag key={tag}>{tag}</Tag>)}
              </Box>
            </GlassCard>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Skills;